const path = `examitems`;

export const state = {
	imagePaths: {
		e8sa: require("@/assets/images/exams/exam8/samplea.png"),
		e8sb: require("@/assets/images/exams/exam8/sampleb.png"),
		e8sc: require("@/assets/images/exams/exam8/samplec.png"),
		e8sc1: require("@/assets/images/exams/exam8/samplec-1.png"),
		e8sc2: require("@/assets/images/exams/exam8/samplec-2.png"),
		e8sc3: require("@/assets/images/exams/exam8/samplec-3.png"),
		e8sc4: require("@/assets/images/exams/exam8/samplec-4.png"),
		e8q1: require("@/assets/images/exams/exam8/question1.png"),
		e8q2: require("@/assets/images/exams/exam8/question2.png"),
		e8q3: require("@/assets/images/exams/exam8/question3.png"),
		e8q4: require("@/assets/images/exams/exam8/question4.png"),
		e8q5: require("@/assets/images/exams/exam8/question5.png"),
		e8q6: require("@/assets/images/exams/exam8/question6.png"),
		e8q7: require("@/assets/images/exams/exam8/question7.png"),
		e8q8: require("@/assets/images/exams/exam8/question8.png"),
		e8q9: require("@/assets/images/exams/exam8/question9.png"),
		e8q10: require("@/assets/images/exams/exam8/question10.png"),
		e8q11: require("@/assets/images/exams/exam8/question11.png"),
		e8q11c1: require("@/assets/images/exams/exam8/question11c1.png"),
		e8q11c2: require("@/assets/images/exams/exam8/question11c2.png"),
		e8q11c3: require("@/assets/images/exams/exam8/question11c3.png"),
		e8q11c4: require("@/assets/images/exams/exam8/question11c4.png"),
		e8q12: require("@/assets/images/exams/exam8/question12.png"),
		e8q12c1: require("@/assets/images/exams/exam8/question12c1.png"),
		e8q12c2: require("@/assets/images/exams/exam8/question12c2.png"),
		e8q12c3: require("@/assets/images/exams/exam8/question12c3.png"),
		e8q12c4: require("@/assets/images/exams/exam8/question12c4.png"),
		e8q13: require("@/assets/images/exams/exam8/question13.png"),
		e8q13c1: require("@/assets/images/exams/exam8/question13c1.png"),
		e8q13c2: require("@/assets/images/exams/exam8/question13c2.png"),
		e8q13c3: require("@/assets/images/exams/exam8/question13c3.png"),
		e8q13c4: require("@/assets/images/exams/exam8/question13c4.png"),
		e8q14: require("@/assets/images/exams/exam8/question14.png"),
		e8q14c1: require("@/assets/images/exams/exam8/question14c1.png"),
		e8q14c2: require("@/assets/images/exams/exam8/question14c2.png"),
		e8q14c3: require("@/assets/images/exams/exam8/question14c3.png"),
		e8q14c4: require("@/assets/images/exams/exam8/question14c4.png"),
		e8q15: require("@/assets/images/exams/exam8/question15.png"),
		e8q15c1: require("@/assets/images/exams/exam8/question15c1.png"),
		e8q15c2: require("@/assets/images/exams/exam8/question15c2.png"),
		e8q15c3: require("@/assets/images/exams/exam8/question15c3.png"),
		e8q15c4: require("@/assets/images/exams/exam8/question15c4.png"),
		e8q16: require("@/assets/images/exams/exam8/question16.png"),
		e8q16c1: require("@/assets/images/exams/exam8/question16c1.png"),
		e8q16c2: require("@/assets/images/exams/exam8/question16c2.png"),
		e8q16c3: require("@/assets/images/exams/exam8/question16c3.png"),
		e8q16c4: require("@/assets/images/exams/exam8/question16c4.png"),
		e8q17: require("@/assets/images/exams/exam8/question17.png"),
		e8q17c1: require("@/assets/images/exams/exam8/question17c1.png"),
		e8q17c2: require("@/assets/images/exams/exam8/question17c2.png"),
		e8q17c3: require("@/assets/images/exams/exam8/question17c3.png"),
		e8q17c4: require("@/assets/images/exams/exam8/question17c4.png"),
		e8q18: require("@/assets/images/exams/exam8/question18.png"),
		e8q18c1: require("@/assets/images/exams/exam8/question18c1.png"),
		e8q18c2: require("@/assets/images/exams/exam8/question18c2.png"),
		e8q18c3: require("@/assets/images/exams/exam8/question18c3.png"),
		e8q18c4: require("@/assets/images/exams/exam8/question18c4.png"),

		e9sa: require("@/assets/images/exams/exam9/samplea.png"),
		e9sb: require("@/assets/images/exams/exam9/sampleb.png"),
		e9q1: require("@/assets/images/exams/exam9/question1.png"),
		e9q2: require("@/assets/images/exams/exam9/question2.png"),
		e9q3: require("@/assets/images/exams/exam9/question3.png"),
		e9q4: require("@/assets/images/exams/exam9/question4.png"),
		e9q5: require("@/assets/images/exams/exam9/question5.png"),
		e9q6: require("@/assets/images/exams/exam9/question6.png"),
		e9q7: require("@/assets/images/exams/exam9/question7.png"),
		e9q8: require("@/assets/images/exams/exam9/question8.png"),
		e9q9: require("@/assets/images/exams/exam9/question9.png"),
		e9q10: require("@/assets/images/exams/exam9/question10.png"),
		e9q11: require("@/assets/images/exams/exam9/question11.png"),
		e9q12: require("@/assets/images/exams/exam9/question12.png"),
		e9q13: require("@/assets/images/exams/exam9/question13.png"),
		e9q14: require("@/assets/images/exams/exam9/question14.png"),
		e9q15: require("@/assets/images/exams/exam9/question15.png"),
		e9q16: require("@/assets/images/exams/exam9/question16.png"),
		e9q17: require("@/assets/images/exams/exam9/question17.png"),
		e9q18: require("@/assets/images/exams/exam9/question18.png"),
		e9q19: require("@/assets/images/exams/exam9/question19.png"),
		e9q20: require("@/assets/images/exams/exam9/question20.png"),

		e10sa: require("@/assets/images/exams/exam10/samplea.png"),
		e10sb: require("@/assets/images/exams/exam10/sampleb.png"),
		e10q1: require("@/assets/images/exams/exam10/question1.png"),
		e10q2: require("@/assets/images/exams/exam10/question2.png"),
		e10q3: require("@/assets/images/exams/exam10/question3.png"),
		e10q4: require("@/assets/images/exams/exam10/question4.png"),
		e10q5: require("@/assets/images/exams/exam10/question5.png"),
		e10q6: require("@/assets/images/exams/exam10/question6.png"),
		e10q7: require("@/assets/images/exams/exam10/question7.png"),
		e10q8: require("@/assets/images/exams/exam10/question8.png"),
		e10q9: require("@/assets/images/exams/exam10/question9.png"),
		e10q10: require("@/assets/images/exams/exam10/question10.png"),
		e10q11: require("@/assets/images/exams/exam10/question11.png"),
		e10q12: require("@/assets/images/exams/exam10/question12.png"),
		e10q13: require("@/assets/images/exams/exam10/question13.png"),
		e10q14: require("@/assets/images/exams/exam10/question14.png"),
		e10q15: require("@/assets/images/exams/exam10/question15.png"),
		e10q16: require("@/assets/images/exams/exam10/question16.png"),
		e10q17: require("@/assets/images/exams/exam10/question17.png"),
	},
	examItemHeaders: {
		e7q1: `
			<h5 class="text-site-primary">
				PART I<br>
				<small>CATEGORIES</small>
			</h5>
			<p class>
				a. rash - cautious <br>
				b. cheerful - dejected <br>
				c. beauty - ugliness <br>
				d. hope - despair <br>
			</p>
		`,
		e7q18: `
			<h5 class="text-site-primary">
				PART II<br>
				<small>CATEGORIES</small>
			</h5>
			<p class>
				e. start - finish<br>
				f. early - late<br>
				g. frequent - infrequent<br>
				h. permanent - transient<br>			
			</p>
		`,
		e13q1 : `
			<br><br>
			SITUATION - <b><i> Mr. Green has bought a new Phantom automobile every year for the past seven years, and none of them has required major motor repairs. He concludes that the new Phantom he is buying will also be trouble-free in this respect. </b></i><br>
			STATEMENTS - <br>
		`,
		e13q5 : `
			<br><br>
			SITUATION - <b><i> Mr. B recommends two restaurants to his friend, Mr. A. Mr. A decides to go to Chez Paris rather than the Town House because he prefers French cooking. </b></i><br>
			STATEMENTS - <br>
		`,
		e13q11 : `
			<br><br>
			SITUATION - <b><i> Some confidential documents have been stolen from a top-secret government file. An investigation narrows the list of suspects to three - John Smith, Bill Jones, and Paul  Brown. After finding a key to the secret file in Brown's desk, an investigator concludes that Brown is guilty of the theft. </b></i><br>
			STATEMENTS - <br>
		`,
		e13q15 : `
			<br><br>
			SITUATION - <b><i> I conclude that this is a Greek vase and that it was made and painted sometime before the birth of Alexander the Great (356 B. C.). My reasoning is that it is comparable in size and shape to several vases I have seen displayed in museums as the work of Greek potters antedating Alexander. Moreover, the painting technique of contrasting human figures in white against a red background, of which is a good example, is said by art historians to have been invented before 500 B.C. </b></i><br>
			STATEMENTS - <br>
		`,
		e13q20 : `
			<br><br>
			SITUATION - <b><i> Mr. Adams, present governor and candidate for reelection, appears to be running ahead of Mr. Brown, the opposition candidate, in the current election campaign. Only one month remains until Election Day, and the pollsters predict a victory for the incumbent candidate. </b></i><br>
			STATEMENTS - <br>
		`,
		e14q180 : `
			<br>
			<div class="border p-4">
			Sagutan o lutasin ang mga sumusunod na tanong ayon sa pagkaunawa mo.  Bawat isa ay may <b>ISA</b> at <b>TANGING ISA</b> na tamang sagot. Kung hindi ka tiyak sa sagot sa tanong, piliin mo ang pinakatamang tantiya.<br>
			<b>HALIMBAWA</b><br>
			&nbsp;&nbsp;&nbsp;&nbsp;<b>ExZ. Ang matanda ay sa bata, habang ang pusa ay sa:</b><br>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label class="radio-inline mr-2"><input type="radio" name="exam14-samplez" disabled checked> <b><i>a. kuting</i></b></label><br>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label class="radio-inline mr-2"><input type="radio" name="exam14-samplez" disabled> <b><i>b. aso</i></b></label><br>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label class="radio-inline mr-2"><input type="radio" name="exam14-samplez" disabled> <b><i>c. sanggol</i></b></label><br>
			Mapapansin mong ang "a. kuting" ang pinakalohikal na sagot.
			</div>
			<br>
		`,
	},
};

export const getters = {
	getImage: (state) => (key) => state.imagePaths[key],
	getHeader: (state) => (key) => {
		return state.examItemHeaders[key]
	},
};

export const mutations = {};

export const actions = {
	// --- Generic Methods
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`getAllOfExam`](store, { examId }) {
		return this._vm.$http.get(`/${path}/ofexam/${examId}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
